const primaryColorScheme = {
  '50': '#FDE8F7',
  '100': '#F8BEE8',
  '200': '#F494D9',
  '300': '#F06BCA',
  '400': '#EC41BC',
  '500': '#BD138D',
  '600': '#B9138A',
  '700': '#8B0E68',
  '800': '#5D0945',
  '900': '#2E0523'
};
export default primaryColorScheme;